module.exports = __webpack_public_path__ + "img/Credential_Engine.a45cf9ed.png";